/**
 * Wire a NetClient up to a one-shot onConnected callback. Used by both the OnlineLobby (for
 * fresh joins) and App (for reloading a /g/<id> URL into an existing GameRoom via rejoinToken).
 */
import { fromWire } from "../../worker/src/serialize";
import type { ServerMessage } from "../../worker/src/protocol";
import type { NetClient } from "../net/client";
import type { OnlineSession } from "./OnlineLobby";

export function attachOnce(
  client: NetClient,
  code: string,
  onConnected: (session: OnlineSession) => void,
  setError: (s: string | null) => void,
): void {
  let resolved = false;
  client.on("message", (msg: ServerMessage) => {
    if (resolved) return;
    if (msg.type === "joined") {
      resolved = true;
      onConnected({
        client,
        mySide: msg.you,
        code,
        initialState: fromWire(msg.state),
        rejoinToken: msg.rejoinToken,
      });
    } else if (msg.type === "error") {
      setError(msg.message);
    }
  });
  client.on("error", () => setError("connection error"));
  client.on("close", () => {
    if (!resolved) setError("connection closed");
  });
}
